import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../logo.png";

export const HomePage = () => {
  return (
    <React.Fragment>
      <section className="bg-gray-900 text-white">
        <div className="mx-auto max-w-screen-xl px-4 py-32 lg:flex lg:items-center">
          <div className="mx-auto max-w-3xl text-center">
            <div className="flex justify-center">
              <img height={100} width={100} src={Logo} alt="" />
            </div>
            <h1 className="bg-gradient-to-r from-green-300 via-blue-500 to-purple-600 bg-clip-text text-3xl font-extrabold text-transparent sm:text-5xl">
              Learn about things around you.
              <span className="sm:block"> Increase knowledge. </span>
            </h1>

            <p className="mx-auto mt-4 max-w-xl sm:text-xl/relaxed">
              You can search any thing like Scientists, Writters, Superheros,
              Celebreties, fruits, flower and more!
            </p>

            <div className="mt-8 flex flex-wrap justify-center gap-4">
              <Link
                className="block w-full rounded border border-blue-600 bg-blue-600 px-12 py-3 text-sm font-medium text-white hover:bg-transparent hover:text-white focus:outline-none focus:ring active:text-opacity-75 sm:w-auto"
                to={"/basic-search"}
              >
                Basic Search
              </Link>
              <Link
                className="block w-full rounded border border-orange-600 bg-orange-600 px-12 py-3 text-sm font-medium text-white hover:bg-transparent hover:text-white focus:outline-none focus:ring active:text-opacity-75 sm:w-auto"
                to={"/advance-search"}
              >
                Advance Search
              </Link>
              <Link
                className="block w-full rounded border border-green-600 px-12 py-3 text-sm font-medium text-white hover:bg-green-600 focus:outline-none focus:ring active:bg-green-500 sm:w-auto"
                to="https://github.com/jotonsd/"
                target="_blank"
              >
                Coffee with me!
              </Link>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export const Spinner = () => {
  return <span className="loader"></span>;
};

export const BasicPage = () => {
  let [state, setState] = useState({
    prompt: "",
    response: "",
    name: "",
    img: ``,
    details: ``,
    error: false,
    loader: false,
  });

  let updateInput = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
  };
  function titleCase(str) {
    var splitStr = str.toLowerCase().split(" ");
    for (var i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(" ");
  }

  let getResponse = async (e) => {
    e.preventDefault();
    setState({
      ...state,
      loader: true,
    });

    try {
      let dataUrl = `https://en.wikipedia.org/api/rest_v1/page/summary/${titleCase(
        state.prompt
      )}`;
      let response = await axios.get(dataUrl, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.data.type !== "disambiguation") {
        setState({
          ...state,
          response: response,
          name: response.data.title,
          img: response.data.originalimage.source,
          details: response.data.extract,
          error: false,
          loader: false,
        });
      } else {
        setState({
          ...state,
          response: response,
          name: response.data.title,
          img: "https://st4.depositphotos.com/14953852/24787/v/450/depositphotos_247872612-stock-illustration-no-image-available-icon-vector.jpg",
          details: response.data.extract,
          error: false,
          loader: false,
        });
      }
    } catch (error) {
      console.log(error.message);
      setState({
        ...state,
        response: "",
        name: "",
        img: ``,
        details: ``,
        error: true,
        loader: false,
      });
    }
  };

  return (
    <React.Fragment>
      <section className="bg-gray-900 text-white">
        <div className="mx-auto max-w-screen-xl px-4 py-8 lg:flex">
          <div className="mx-auto max-w-3xl text-center">
            <div className="flex items-center">
              <Link
                to={"/"}
                className="focus:outline-none text-white bg-yellow-400 hover:bg-yellow-500 focus:ring-4 focus:ring-yellow-300 font-medium rounded-lg text-sm px-3 py-2.5 me-1  dark:focus:ring-yellow-900"
              >
                <img height={20} width={20} src={Logo} alt="" />
              </Link>
              <h1 className="bg-gradient-to-r from-green-300 via-blue-500 to-purple-600 bg-clip-text text-3xl font-extrabold text-transparent sm:text-4xl">
                Search by name what you want to know!
              </h1>
            </div>

            <form onSubmit={getResponse}>
              <label
                htmlFor="search"
                className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
              >
                Search
              </label>
              <div className="relative my-3">
                <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                  <svg
                    className="w-4 h-4 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 20"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                    />
                  </svg>
                </div>
                <input
                  type="search"
                  name="prompt"
                  onChange={updateInput}
                  value={state.prompt}
                  id="search"
                  className="block w-full p-4 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Search"
                  requiblue
                />
                <button
                  type="submit"
                  className="text-white absolute end-2.5 bottom-2.5 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                >
                  Search
                </button>
              </div>
            </form>
          </div>
        </div>
        {state.loader ? <Spinner /> : ""}
        {state.name && state.loader === false && state.error === false && (
          <div className="mx-auto max-w-screen-xl px-4 py-0 lg:flex">
            <div className="mx-auto max-w-3xl">
              <div className="container max-w-screen-lg mx-auto pb-5 flex justify-center">
                <img
                  height={200}
                  width={170}
                  className="object-cover rounded-lg"
                  src={state.img}
                  alt={state.name}
                />
              </div>
              <div className="text-center">
                <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 text-white">
                  {state.name}
                </h2>
                <p>{state.details}</p>
              </div>
            </div>
          </div>
        )}
        {state.error === true && state.loader === false && (
          <div className="mx-auto max-w-screen-xl px-4 py-0 lg:flex">
            <div className="mx-auto max-w-3xl">
              <h1 className="bg-gradient-to-r text-white bg-clip-text text-3xl font-extrabold text-transparent sm:text-5xl">
                Opps! Not Found. Please try again with actual spelling.
              </h1>
            </div>
          </div>
        )}
      </section>
    </React.Fragment>
  );
};

export const DetailPage = () => {
  const [showButton, setShowButton] = useState(false);

  const handleScroll = () => {
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      setShowButton(true);
    } else {
      setShowButton(false);
    }
  };

  const backToTop = () => {
    document.documentElement.style.scrollBehavior = "smooth";
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  let [state, setState] = useState({
    prompt: "",
    response: "",
    name: "",
    img: ``,
    details: ``,
    notMatchNote: ``,
    error: false,
    loader: false,
  });

  let updateInput = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
  };
  function titleCase(str) {
    var splitStr = str.toLowerCase().split(" ");
    for (var i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(" ");
  }

  let getImage = async (title) => {
    try {
      let dataUrl2 = `https://en.wikipedia.org/api/rest_v1/page/summary/${title}`;
      let response = await axios.get(dataUrl2, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return (
        response.data?.originalimage?.source ??
        "https://st4.depositphotos.com/14953852/24787/v/450/depositphotos_247872612-stock-illustration-no-image-available-icon-vector.jpg"
      );
    } catch (error) {
      console.log(error.message);
      return "https://st4.depositphotos.com/14953852/24787/v/450/depositphotos_247872612-stock-illustration-no-image-available-icon-vector.jpg";
    }
  };

  let getResponse = async (e) => {
    e.preventDefault();
    setState({
      ...state,
      loader: true,
    });

    try {
      let dataUrl = `https://en.wikipedia.org/w/api.php?action=query&prop=extracts&origin=*&format=json&generator=search&gsrnamespace=0&gsrlimit=1&gsrsearch=${titleCase(
        state.prompt
      )}`;

      let responseDetails = await axios.get(dataUrl, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      let detailsInfo = responseDetails.data.query.pages;
      let index = Object.keys(detailsInfo);
      let titleImg = await getImage(detailsInfo[index[0]].title);
      setState({
        ...state,
        img: titleImg,
        name: detailsInfo[index[0]].title,
        details: detailsInfo[index[0]].extract,
        error: false,
        loader: false,
        // notMatchNote:
        //   titleCase(state.prompt) !== detailsInfo[index[0]].title
        //     ? "Sorry we don't find exact your search but showing related result"
        //     : ``
      });
    } catch (error) {
      console.log(error.message);
      setState({
        ...state,
        response: "",
        name: "",
        img: ``,
        details: ``,
        notMatchNote: ``,
        error: true,
        loader: false,
      });
    }
  };

  return (
    <React.Fragment>
      <section className="bg-gray-900 text-white">
        <div className="mx-auto max-w-screen-xl px-4 py-8 lg:flex">
          <div className="mx-auto max-w-3xl text-center">
            <div className="flex items-center">
              <Link
                to={"/"}
                className="focus:outline-none text-white bg-yellow-400 hover:bg-yellow-500 focus:ring-4 focus:ring-yellow-300 font-medium rounded-lg text-sm px-3 py-2.5 me-1  dark:focus:ring-yellow-900"
              >
                <img height={20} width={20} src={Logo} alt="" />
              </Link>
              <h1 className="bg-gradient-to-r from-green-300 via-blue-500 to-purple-600 bg-clip-text text-3xl font-extrabold text-transparent sm:text-4xl">
                Search by name what you want to know!
              </h1>
            </div>

            <form onSubmit={getResponse}>
              <label
                htmlFor="search"
                className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
              >
                Search
              </label>
              <div className="relative mt-3">
                <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                  <svg
                    className="w-4 h-4 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 20"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                    />
                  </svg>
                </div>
                <input
                  type="search"
                  name="prompt"
                  onChange={updateInput}
                  value={state.prompt}
                  id="search"
                  className="block w-full p-4 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Search"
                  requiblue
                />
                <button
                  type="submit"
                  className="text-white absolute end-2.5 bottom-2.5 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                >
                  Search
                </button>
              </div>
            </form>
          </div>
        </div>
        {state.loader ? <Spinner /> : ""}
        {state.name && state.loader === false && state.error === false && (
          <div className="mx-auto max-w-screen-xl px-4 py-0 lg:flex">
            <div className="mx-auto max-w-3xl">
              {state.notMatchNote && (
                <p className="italic mb-5">{state.notMatchNote} ...</p>
              )}
              <div className="container max-w-screen-lg mx-auto pb-5 flex justify-center">
                <img
                  height={200}
                  width={170}
                  className="object-cover rounded-lg"
                  src={state.img}
                  alt={state.name}
                />
              </div>
              <div className="text-center">
                <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 text-white">
                  {state.name}
                </h2>
                <div
                  className="text-left"
                  dangerouslySetInnerHTML={{ __html: state.details }}
                />
              </div>
            </div>
          </div>
        )}
        {state.error === true && state.loader === false && (
          <div className="mx-auto max-w-screen-xl px-4 py-0 lg:flex">
            <div className="mx-auto max-w-3xl">
              <h1 className="bg-gradient-to-r text-white bg-clip-text text-3xl font-extrabold text-transparent sm:text-5xl">
                Opps! Not Found. Please try again with actual spelling.
              </h1>
            </div>
          </div>
        )}
      </section>
      {showButton && (
        // <TERipple rippleColor='light'>
        <button
          type="button"
          onClick={backToTop}
          className={` ${
            showButton ? `inline-block` : `hidden`
          } fixed bottom-[40px] right-[40px] p-3 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded-full shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out`}
        >
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            className="w-4 h-4"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <path
              fill="currentColor"
              d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
            ></path>
          </svg>
        </button>
        // </TERipple>
      )}
    </React.Fragment>
  );
};

export const PageNotFound = () => {
  return (
    <React.Fragment>
      <section className="bg-gray-900 text-white">
        <div className="mx-auto max-w-screen-xl px-4 py-32 lg:flex lg:items-center">
          <div className="mx-auto max-w-3xl text-center">
            <div className="flex justify-center">
              <img height={100} width={100} src={Logo} alt="" />
            </div>
            <h1 className="bg-gradient-to-r from-green-300 via-blue-500 to-purple-600 bg-clip-text text-3xl font-extrabold text-transparent sm:text-5xl">
              404
              <br />
              Opps! Page Not Found!
            </h1>
            <div className="mt-8 flex flex-wrap justify-center gap-4">
              <Link
                className="block w-full rounded border border-blue-600 bg-blue-600 px-12 py-3 text-sm font-medium text-white hover:bg-transparent hover:text-white focus:outline-none focus:ring active:text-opacity-75 sm:w-auto"
                to={"/"}
              >
                Back to home page
              </Link>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};
